import { z } from 'zod';

export const textSchema = z.object({
  _id: z.string(),
  __typename: z.literal('Text'),
  html: z.string(),
  body: z.string(),
  text: z.string(),
  format: z
    .union([
      z.literal('H1'),
      z.literal('H2'),
      z.literal('H3'),
      z.literal('H4'),
      z.literal('H5'),
      z.literal('H6'),
      z.literal('HTML'),
      z.literal('Code'),
    ])
    .nullable(),
});

export type IText = z.infer<typeof textSchema>;
